// extracted by mini-css-extract-plugin
module.exports = {"button":"H1lmqltRSXz0sg2-wVoM6","icon":"_1EH8JrfVmzDfPNN9-UPh3x"};